import React, { useMemo } from "react";
import { IconBaseProps, IconType } from "react-icons";

import {
  OutlinedButtonStyle as Button,
  LeadingIconContainer,
  TrailingIconContainer,
} from "./styles";

type ContainedButtonProps = React.HTMLProps<HTMLButtonElement> & {
  LeadingIcon?: IconType | any;
  propsLeadingIcon?: IconBaseProps;
  TrailingIcon?: IconType | any;
  propsTrailingIcon?: IconBaseProps;
  type?: string;
  loading?: boolean;
  block?: boolean;
  outline?: boolean;
};

const OutlinedButton = ({
  loading = false,
  LeadingIcon,
  propsLeadingIcon,
  TrailingIcon,
  propsTrailingIcon,
  children,
  ...rest
}: ContainedButtonProps): JSX.Element => {
  const LeftIcon = useMemo(() => {
    switch (typeof LeadingIcon) {
      case "function":
        return LeadingIcon();
      case "object":
        return LeadingIcon;
      default:
        return <LeadingIcon {...propsLeadingIcon} />;
    }
  }, [LeadingIcon]);

  const RightIcon = useMemo(() => {
    switch (typeof TrailingIcon) {
      case "function":
        return TrailingIcon();
      case "object":
        return TrailingIcon;
      default:
        return <TrailingIcon {...propsTrailingIcon} />;
    }
  }, [LeadingIcon]);

  return (
    // TODO: Revisar erro de TS
    // @ts-ignore
    <Button {...rest}>
      {loading ? (
        <span>
          <i
            style={{ fontSize: 20, marginTop: 5 }}
            className="fa fa-spinner fa-pulse fa-3x fa-fw"
          />
        </span>
      ) : (
        <>
          {LeadingIcon && (
            <LeadingIconContainer>{LeftIcon}</LeadingIconContainer>
          )}
          <span>{children}</span>
          {TrailingIcon && (
            <TrailingIconContainer>{RightIcon}</TrailingIconContainer>
          )}
        </>
      )}
    </Button>
  );
};

OutlinedButton.defaultProps = {
  type: "button",
  loading: false,
};

export default OutlinedButton;
